module.exports = __webpack_public_path__ + "fonts/Inter-400-latin-ext48.ad4eb06.woff2";